var giphy_viewer_default = {
  "giphyWrapper": "E2MI2",
  "giphy_player": "JFQWG",
  "playIcon": "iF40B",
  "gifRatio": "eStO1"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
